import type { TFunction } from 'i18next';
import type { IToast } from '@components/ui/Toasts/useToasts';

/** What the user is told when the server refuses a done for an open checklist
 *  — one wording for the step button and the finish dialog. */
export function checklistRefusedToast(t: TFunction): Omit<IToast, 'id'> {
  return { kind: 'error', title: t('scheduler.panel.checklist.refused'), sub: t('scheduler.panel.checklist.refusedSub') };
}
